import { Link } from 'react-router-dom'
import { api } from '../../lib/api.js'
import { useHatcheryScope } from '../../lib/scope.js'
import { Card, ErrorBox, KV, Page, Spinner, useAsync } from '../../components/Ui.jsx'
import { inr, lakh } from '../../lib/format.js'

export default function Profile () {
  const scope = useHatcheryScope()
  const { data, error, loading, reload } = useAsync(
    () => (scope.missing ? Promise.resolve(null) : api.get(`/hatchery/summary${scope.query}`)),
    [scope.query]
  )

  if (scope.missing) {
    return (
      <Page title="Hatchery profile">
        <div className="alert info"><div>Open a hatchery from the <Link to="/admin/hatcheries">hatcheries list</Link> first.</div></div>
      </Page>
    )
  }
  if (loading) return <Page title="Hatchery profile"><Spinner /></Page>
  if (error) return <Page title="Hatchery profile"><ErrorBox error={error} onRetry={reload} /></Page>

  const h = data.hatchery
  const t = data.totals

  return (
    <Page
      title={h.name}
      subtitle={`${h.code} · ${h.place}`}
      actions={scope.asAdmin ? <Link className="btn" to={`/admin/hatcheries/${h._id}/edit`}>Edit profile</Link> : null}
    >
      {!scope.asAdmin && (
        <div className="alert info">
          <div>
            <b>Need a detail changed?</b>
            Registration, location and contact details are maintained by the platform admin — call the desk and they will update it.
          </div>
        </div>
      )}

      <div className="split">
        <Card title="Registered details">
          <KV items={[
            { k: 'Hatchery code', v: <span className="mono">{h.code}</span> },
            { k: 'Owner / contact', v: h.ownerName },
            { k: 'Phone', v: h.phone },
            { k: 'Email', v: h.email },
            { k: 'CAA registration', v: <span className="mono">{h.caaRegistrationNo || '—'}</span> },
            { k: 'Annual capacity', v: h.annualCapacityCr ? `${h.annualCapacityCr} crore PL` : '—' },
            { k: 'Location', v: h.place },
            { k: 'Coordinates', v: <span className="mono small">{h.lat}, {h.lng}</span> }
          ]} />
          {h.broodstockPartners && <>
            <div className="divider" />
            <div className="flabel">Broodstock partners</div>
            <div>{h.broodstockPartners}</div>
          </>}
          {h.biosecurityNotes && <>
            <div className="divider" />
            <div className="flabel">Biosecurity</div>
            <div className="small">{h.biosecurityNotes}</div>
          </>}
        </Card>

        <Card title="Business through the platform">
          <KV items={[
            { k: 'Seed supplied', v: lakh(t.seedLakh), big: true },
            { k: 'Order value', v: inr(t.value), big: true },
            { k: 'Received from platform', v: inr(t.paidOut), big: true }
          ]} />
          <div className="divider" />
          <p className="muted small mb0">
            The platform collects the full amount from the farmer and settles it to you, less commission,
            before you pack. Transport from your gate to the pond is arranged and escorted by the platform.
          </p>
        </Card>
      </div>
    </Page>
  )
}
